<h2 mat-dialog-title data-testid="generic-confirmation-dialog-dialog-title">{{ title }}</h2>
<hr>
<mat-dialog-content data-testid="generic-confirmation-dialog-dialog-content">
  <p>{{ message }}</p>
</mat-dialog-content>
<hr>
<mat-dialog-actions data-testid="generic-confirmation-dialog-dialog-actions" align="end">
  <button mat-button (click)="cancel()" data-testid="generic-confirmation-dialog-cancel-button">{{ cancelLabel }}</button>
  <button mat-raised-button color="primary" (click)="confirm()" data-testid="generic-confirmation-dialog-confirm-button">{{ confirmLabel }}</button>
</mat-dialog-actions>